import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

export interface RedirectToClassicProps {
  showMessage?: boolean,
  to?: string,
}

export const RedirectToClassic = ({ to, showMessage = true }: RedirectToClassicProps): ReactElement => {
  const { t } = useTranslation()
  const location = useLocation()
  const routerString = to ? to : `${location.pathname}${location.search}`
  const classicUri = `/classic/#${routerString}`
  window.location.href = classicUri
  return <div>{ showMessage ? t('classicExperienceRedirect') : '' }</div>
}
